import { useContext, useEffect, useMemo, useState } from 'react'
import { WalletAddressContext } from '@/lib/walletContext'
import { getSimPresale, listSimPresales, subscribeSimPresales } from '@/lib/presale/store'
import { pledgedByWallet } from '@/lib/presale/math'
import type { SimPresale } from '@/lib/presale/types'

export function useSimPresales() {
  const address = useContext(WalletAddressContext)
  const [tick, setTick] = useState(0)

  useEffect(() => subscribeSimPresales(() => setTick(value => value + 1)), [])

  const presales = useMemo(() => listSimPresales(), [tick])

  return { presales, address, tick }
}

export function useSimPresale(id: string | undefined): SimPresale | undefined {
  const { tick } = useSimPresales()
  return useMemo(() => (id ? getSimPresale(id) : undefined), [id, tick])
}

export function useSimPresalePledge(id: string | undefined): bigint {
  const address = useContext(WalletAddressContext)
  const presale = useSimPresale(id)
  return useMemo(() => (presale ? pledgedByWallet(presale, address) : 0n), [address, presale])
}
